<div class="alert-container" #alertContainer [@openState]="state" (@openState.start)="alertOpened($event)" (window:resize)="onResize($event)">
  <div class="alert" [ngClass]=" 'alert-' + type " (click)="close()">
    <t-icon name="check" *ngIf="type === 'success'"></t-icon>
    <t-icon name="close" *ngIf="type === 'error'"></t-icon>
    <div class="message">
      {{ message }}
    </div>
  </div>
</div>